import React, { useState } from 'react';
import '../App.css';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid';

const NavBar = () => {
  const Links = [
    { name: "Home", link: "/" },
    { name: 'Skills', link: '#skills' },
    { name: "Projects", link: "#projects" },
    { name: "Experience", link: "#experience" },
    { name: "Certifications", link: "#Certifications" },
    { name: "Contact", link: "#contact" },
  ];

  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className="w-full">
      {/* Upper Section: Always Visible */}
      <div className="fixed top-0 z-50 bg-[#522258] py-4 md:px-10 px-7 w-full">
        <div className="flex items-center justify-between">
          <div className="font-bold text-2xl flex items-center font-[Poppins] text-white">
            MSS
          </div>

          <div onClick={() => setToggleMenu(!toggleMenu)} className="text-3xl cursor-pointer md:hidden">
            {toggleMenu ? <ChevronUpIcon className="size-8" /> : <ChevronDownIcon className="size-8" />}
          </div>

          <ul className={`md:flex md:items-center absolute md:static bg-[#522258] md:z-auto z-[50] left-0 w-full md:w-auto md:pl-0 px-3 transition-all duration-500 ease-in ${toggleMenu ? 'top-16' : 'top-[-490px]'}`}>
            {Links.map((link) => (
              <li onClick={() => setToggleMenu(false)} key={link.name} className="md:ml-8 text-l py-2 text-center rounded-md">
                <a href={link.link} className="text-white hover:text-[#8C3061] md:mr-14">{link.name}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Lower Section: Scrollable */}
      <div className="bg-[#522258] md:py-24 py-10 px-7">
      </div>
    </div>
  );
};

export default NavBar;
